<template>
  <div>
    <div>
      <detail-block :trip_details="trip_details" :trip_id="trip_id" />
    </div>
    <!-- returned shipment list -->
    <div>
      <v-row class="">
        <v-col md="6">
          <span class="page-title">
            {{ $lang.SHIPMENTS.toUpperCase() }} | {{ shipment_list.length }}
          </span>
        </v-col>
      </v-row>
      <!-- show-select -->
      <div class="mb-5">
        <v-data-table
          :headers="headers"
          :items="shipment_list"
          :hide-default-footer="true"
          :disable-sort="true"
          :items-per-page="shipment_list.length"
          class="elevation-1 custome-header-bg custome-table-body"
          :loading="table_loading"
        >
          <template v-slot:item.action="{ item }">
            <v-btn
              small
              fab
              text
              @click="
                $router.push({
                  name: 'shipment-details',
                  params: { shipment_id: encript(item.shipment_id) },
                })
              "
            >
              <img src="../../assets/arrow-right.svg" alt="" />
            </v-btn>
          </template>
          <template v-slot:item.shipment_status="{ item }">
            <span :class="getClassSatus(item.shipment_status)">{{
              item.shipment_status
            }}</span>
          </template>
        </v-data-table>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  components: {
    DetailBlock: () => import("./child/TripDetailBlock.vue"),
  },
  data() {
    return {
      trip_id: "",
      trip_details: {
        amount: "",
        received_on: "",
        recipient_name: "",
        shipment_count: "",
        transaction_id: "",
        transaction_otp: "",
      },

      shipment_list: [],
      table_loading: false,
      headers: [
        {
          text: "Shipment ID",
          align: "start",
          sortable: false,
          value: "shipment_id",
        },
        { text: "Retailer Info", value: "retailer_firm_name" },
        // { text: 'Packages', value: 'no_of_packages' },
        { text: "Location", value: "location" },
        { text: "Amount", value: "shipment_amount" },
        { text: "Mode", value: "payment_mode" },
        { text: "Status", value: "shipment_status" },
        { text: "", value: "action" },
      ],
    };
  },
  created() {
    if (this.$route.name == "collection-details")
      this.$store.dispatch("drawer/setActiveTab", "collection");

    if (this.$route.params.trip_id) {
      this.trip_id = this.decrypt(this.$route.params.trip_id);
      this.getTripDetails();
    }
  },

  methods: {
    getTripDetails() {
      const self = this;
      let params = {
        id: this.trip_id,
      };
      self.table_loading = true;

      const successHandler = (response) => {
        if (response.data.success) {
          console.log(response);
          self.trip_details = response.data;
          self.shipment_list = response.data.shipment_list;
        }
      };
      const finallyHandler = () => {
        self.table_loading = false;
        this.$store.dispatch("setPageLoader", false);
      };

      self.request_GET(
        self,
        self.$urls.TRIP_DETAILS,
        params,
        successHandler,
        null,
        null,
        finallyHandler
      );
    },
  },
};
</script>